module.exports = __webpack_public_path__ + "static/img/dd_fast-import.3478001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/dd_fast-import.png
// module id = 1756
// module chunks = 0